export const CREATE_AUDIOSTREAM = gql`
  mutation CreateAudiostream($input: CreateAudiostreamInput!) {
    createAudiostream(input: $input) {
      id
      logo
      name
      slug
      streamScheduleId
      sources {
        profile
        url
        weight
      }
    }
  }
`

export const UPDATE_AUDIOSTREAM = gql`
  mutation UpdateAudiostream($id: String!, $input: UpdateAudiostreamInput!) {
    updateAudiostream(id: $id, input: $input) {
      id
      logo
      name
      slug
      streamScheduleId
      sources {
        profile
        url
        weight
      }
      weight
    }
  }
`

export const DELETE_AUDIOSTREAM = gql`
  mutation deleteAudiostream($id: String!) {
    deleteAudiostream(id: $id) {
      id
    }
  }
`

export const GET_STATION_AUDIOSTREAMS = gql`
  query GetStationAudiostreams($stationId: UUID!) {
    stationAudiostreams(stationId: $stationId) {
      id
      slug
      name
      logo
      sources {
        profile
        url
        weight
      }
      streamScheduleId
      weight
    }
  }
`
